import React, { useContext, useState } from "react";
import { Alert, Space, PageHeader, Segmented, Row, Col, Tabs } from "antd";

import { GlobalContext } from "../GlobalContext";

import ProfilePreview from "./ProfilePreview";
import SettingsNamePlate from "./SettingsNamePlate";
import SettingsRankPanel from "./SettingsRankPanel";
import SettingsSongOptions from "./SettingsSongOptions";
import CostumeSelect from "./CostumeSelect";

const Profile = () => {
    const { userData, setProfile } = useContext(GlobalContext);
    const [currentPlayer, setCurrentPlayer] = useState(1);

    return (
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <PageHeader className="site-page-header" title="Profile" />

            {/* <Row style={{ padding: "0 24px" }}>
                <Alert
                    message="This page is currently in active development. Some features may be missing."
                    type="warning"
                    showIcon
                    style={{
                        width: "100%",
                    }}
                    closable
                />
            </Row> */}

            <div
                style={{
                    padding: `0 24px`,
                }}
            >
                <Segmented
                    value={currentPlayer}
                    onChange={(value) => setCurrentPlayer(value)}
                    options={[
                        {
                            label: "Player 1",
                            value: 1,
                        },
                        {
                            label: "Player 2",
                            value: 2,
                        },
                    ]}
                    style={{
                        marginBottom: "24px",
                    }}
                />
            </div>
            <div
                style={{
                    padding: `0 24px 50px`,
                }}
            >
                <Tabs defaultActiveKey="1" size="medium">
                    <Tabs.TabPane tab="Nameplate & Scoreboard" key="1">
                        <Row gutter={16}>
                            <Col
                                md={{
                                    span: 24,
                                    offset: 0,
                                }}
                                lg={{
                                    span: 9,
                                    push: 15,
                                }}
                            >
                                <ProfilePreview
                                    currentPlayer={currentPlayer}
                                    userData={userData}
                                />
                            </Col>
                            <Col
                                md={{
                                    span: 24,
                                    offset: 0,
                                }}
                                lg={{
                                    span: 15,
                                    pull: 9,
                                }}
                            >
                                <SettingsNamePlate
                                    currentPlayer={currentPlayer}
                                    userData={userData}
                                    setProfile={setProfile}
                                />

                                <SettingsRankPanel
                                    currentPlayer={currentPlayer}
                                    userData={userData}
                                    setProfile={setProfile}
                                />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Player Costume" key="2">
                        <Col
                            md={{
                                span: 24,
                                offset: 0,
                            }}
                            lg={{
                                span: 24,
                            }}
                        >
                            <CostumeSelect
                                currentPlayer={currentPlayer}
                                userData={userData}
                                setProfile={setProfile}
                            />
                        </Col>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Song Options" key="3">
                        <Row gutter={16}>
                            <Col
                                md={{
                                    span: 24,
                                    offset: 0,
                                }}
                                lg={{
                                    span: 15,
                                }}
                            >
                                <SettingsSongOptions
                                    currentPlayer={currentPlayer}
                                    userData={userData}
                                    setProfile={setProfile}
                                />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </Space>
    );
};

export default Profile;
